"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectOptionPropType = exports.iconPropType = exports.tagPropType = exports.stringOrNumber = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var stringOrNumber = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);

exports.stringOrNumber = stringOrNumber;

var tagPropType = _propTypes.default.oneOfType([
/* Function that returns a component to render */
_propTypes.default.func,
/* Name of a tag to render */
_propTypes.default.string,
/* render prop */
_propTypes.default.shape({
  $$typeof: _propTypes.default.symbol,
  render: _propTypes.default.func
})]);

exports.tagPropType = tagPropType;

var iconPropType = _propTypes.default.shape({
  /** Font Awesome icon name (omit fa-) */
  name: _propTypes.default.string.isRequired,

  /** Icon family: regular, solid, light, or brand (regular is default) */
  family: _propTypes.default.oneOf(['regular', 'solid', 'light', 'brand'])
});

exports.iconPropType = iconPropType;

var selectOptionPropType = _propTypes.default.exact({
  /* text for a select option, what is visible to the user */
  text: _propTypes.default.string.isRequired,

  /* value of the select box, can be a string or a number */
  value: stringOrNumber.isRequired
});

exports.selectOptionPropType = selectOptionPropType;